import { FormControl, Input, Stack } from "@chakra-ui/react"
import { ErrorMessage, Formik } from "formik"
import { ComponentProps, FC } from "react"
import { ErrorMessageField } from "src/components/ui"
import { DrawerForm } from "src/components/ui/DrawerForm"
import { InputLabel } from "src/components/ui/InputLabel"
import { FormikOnSubmit } from "src/utils/types"
import { IProductAddFormFields } from "."

interface Props extends Omit<ComponentProps<typeof DrawerForm>, "children"> {
	handleSubmit: FormikOnSubmit<IProductAddFormFields>
}

export const ProductAddDrawerFormView: FC<Props> = ({ handleSubmit, ...rest }) => (
	<Formik<IProductAddFormFields>
		initialValues={{ name: "", note: "" }}
		onSubmit={handleSubmit}
		enableReinitialize
	>
		{({ isSubmitting, handleChange }) => (
			<DrawerForm
				size="sm"
				headerLabel="Add Product"
				submitLabel="Save"
				isSubmitting={isSubmitting}
				{...rest}
			>
				<Stack maxWidth={"sm"} marginX={"auto"}>
					{/* Name */}
					<FormControl>
						<InputLabel label="Product Name" />
						<Input
							name="name"
							placeholder="Name"
							maxLength={50}
							required
							autoFocus
							onChange={handleChange}
						/>
						<ErrorMessage component={ErrorMessageField} name="name" />
					</FormControl>
				</Stack>
			</DrawerForm>
		)}
	</Formik>
)
